module.exports = __webpack_public_path__ + "static/5-f5b6d042a588dc981e240ba63f454482.png";